module.exports = __webpack_public_path__ + "static/media/subjectIcon.303196eb.svg";